import { stockLocations, type StockItem, type StockLocation } from '../types/stock'

/**
 * Voorraadwaarde op dit moment: stand × inkoopprijs (excl. btw), per plek. Voor de boekhouder
 * (balanspost "voorraad") en voor Sarah. Een negatieve stand (verkocht na een te hoge telling)
 * telt als 0: je kunt geen negatieve voorraad bezitten. Zonder inkoopprijs telt het artikel niet
 * mee en staat het apart in `withoutCost`, zodat het getal nooit stil te laag lijkt.
 */
export type StockValue = {
  byLocation: Record<StockLocation, number>
  totalCents: number
  /** Artikelen met voorraad maar zonder inkoopprijs. */
  withoutCost: number
}

export function stockValue(items: readonly StockItem[]): StockValue {
  const byLocation = Object.fromEntries(stockLocations.map((l) => [l, 0])) as Record<StockLocation, number>
  let withoutCost = 0
  items.forEach((i) => {
    const pieces = stockLocations.reduce((s, l) => s + Math.max(0, i.levels[l] ?? 0), 0)
    if (pieces === 0) return
    if (i.costPriceCents === undefined) {
      withoutCost += 1
      return
    }
    stockLocations.forEach((l) => {
      byLocation[l] += Math.max(0, i.levels[l] ?? 0) * (i.costPriceCents ?? 0)
    })
  })
  const totalCents = stockLocations.reduce((s, l) => s + byLocation[l], 0)
  return { byLocation, totalCents, withoutCost }
}
